"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var content_1 = __importDefault(require("./content"));
var Influencers_1 = __importDefault(require("./Influencers"));
var health_1 = __importDefault(require("./health"));
var Sports_1 = __importDefault(require("./Sports"));
var Music_1 = __importDefault(require("./Music"));
function Stars() {
    var pages = ["fitness", "influencer", "sports", "music"];
    var param = window.location.pathname.split("/")[2];
    var pageCheck = pages.find(function (x) { return x === param; });
    var showPage = function () {
        switch (param) {
            case "fitness":
                return (0, jsx_runtime_1.jsx)(health_1.default, {});
            case "influencer":
                return (0, jsx_runtime_1.jsx)(Influencers_1.default, {});
            case "music":
                return (0, jsx_runtime_1.jsx)(Music_1.default, {});
            case "sports":
                return (0, jsx_runtime_1.jsx)(Sports_1.default, {});
            default:
                return (0, jsx_runtime_1.jsx)(content_1.default, {});
        }
    };
    return ((0, jsx_runtime_1.jsx)("main", __assign({ className: "homepage HomePageFull" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "home" }, { children: pageCheck ? showPage() : (0, jsx_runtime_1.jsx)(content_1.default, {}) })) })));
}
exports.default = Stars;
